import * as React from 'react';
import { IConnectedAppBarProps } from '@microsoft/portal-app/lib/App/ConnectedStandardAppBar';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';

import { ConnectedAnonymousHeader } from '../../Header/ConnectedAnonymousHeader';
import { useGetTenantBannerLogo } from '../hooks/useGetTenantBannerLogo';
import { useGetTenantDisplayNameUnauthenticated } from '../hooks/useGetTenantDisplayName';

export const ConsentHeader: React.FC<IConnectedAppBarProps> = (props) => {
  const [t] = useLocalization('Account');
  const getTenantBannerLogo = useGetTenantBannerLogo();
  const tenantBannerLogo = getTenantBannerLogo.data;

  const getTenantDisplayNameQuery = useGetTenantDisplayNameUnauthenticated();
  const tenantDisplayName = getTenantDisplayNameQuery.data || '';

  return (
    <ConnectedAnonymousHeader
      t={t}
      tenantLogoUrl={tenantBannerLogo}
      tenantName={tenantDisplayName}
      titleVisible={false}
      {...props}
    />
  );
};
